$(() => {
  if ($('body').is('.information-worksheets-page')) {
    const worksheetsDemo = {
      setup() {
        this.cacheElements();
        this.bindEvents();
        this.init();
      },

      cacheElements() {
        this.$worksheetsDemo = $('#worksheets-demo-media');
        this.$worksheetsDemoCurrentSubject = $(
          '#worksheets-demo-current-subject'
        );
        this.$worksheetsDemoNav = $('#worksheets-demo-nav');
        this.$worksheetsDemoToggle = $('#worksheets-demo-toggle');
        this.$worksheetsHeaderBackground = $('.worksheets-header');
        this.$worksheetsBottomBackground = $('.worksheets-trust-section');
        this.$downloadButton = $('.information-worksheets-download');
        this.$globalBanner = $('.global-banner-frame__container');
      },

      bindEvents() {
        this.$worksheetsDemoNav.on(
          'click',
          '.information-dropdown-subject',
          e => this.selectSubject(e, e.target)
        );
        this.$worksheetsDemoCurrentSubject.on('click', e =>
          this.toggleDropdown(e)
        );
        $(document).on('click', () => $('#worksheets-demo-toggle').hide());
      },

      init() {
        this.$worksheetsDemo.addClass('is-initial');
        const activeVideo = $('.is-active > video', this.$worksheetsDemo);
        activeVideo.on('canplaythrough', () => this.startVideo());
        if (activeVideo[0]?.readyState > 3) {
          this.startVideo();
        }
      },

      selectSubject(e, elem) {
        const $subjectItem = $(elem).closest('li');
        const subject = $subjectItem.data('subject');
        const subjectValue = $subjectItem.children('span').text();

        $('span', this.$worksheetsDemoCurrentSubject).text(subjectValue);
        $('.sprites-subjects-24', this.$worksheetsDemoCurrentSubject)
          .removeClass()
          .addClass(`sprites-subjects-24 sprites-subjects-24--${subject}`);

        $('li', this.$worksheetsDemoToggle).show();
        $subjectItem.hide();

        this.$worksheetsDemo
          .removeClass('is-initial is-finished')
          .addClass('is-playing');
        $('.is-active', this.$worksheetsDemo).removeClass('is-active');
        $(
          `.information-worksheets-demo--${subject}`,
          this.$worksheetsDemo
        ).addClass('is-active');

        this.$worksheetsHeaderBackground
          .removeClass()
          .addClass(`worksheets-header worksheets-header__${subject}`);
        this.$worksheetsBottomBackground
          .removeClass()
          .addClass(
            `worksheets-trust-section worksheets-trust-section__${subject}`
          );

        this.$downloadButton.removeClass('is-active');
        $(`.information-worksheets-download--${subject}`)
          .addClass('information-worksheets-download')
          .addClass('is-active');

        this.$globalBanner
          .removeClass()
          .addClass(
            `global-banner-frame__container global-banner-frame--information-${subject}`
          );
      },

      toggleDropdown(e) {
        $('#worksheets-demo-toggle').slideToggle('fast');
        e.stopPropagation();
      }
    };

    worksheetsDemo.setup();
  }
});
